export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const SET_DATA_LIST = "SET_DATA_LIST";
export const SET_TOTAL = "SET_TOTAL";
export const SET_COURSES_AND_THEORY_LESSONS = "SET_COURSES_AND_THEORY_LESSONS";
export const SET_UPCOMING_THEORY_COURSES = "SET_UPCOMING_THEORY_COURSES";
export const SET_STUDENT_FILTER_THEORY_COURSES = "SET_STUDENT_FILTER_THEORY_COURSES";
